import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { getAllPermissionsKey } from "./useGetAllPermissions.ts";

export const usePermissionDelete = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (id: number) => {
            return await loggedInApiCall.delete(`/api/permissions/${id}`);
        },
        onSuccess: () => queryClient.invalidateQueries([getAllPermissionsKey]),
    });
};
